export default __webpack_public_path__ + "static/media/login-bg.247f90de.png";